import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import getUrl from '../utils/getUrl';
import { sendEvent, hrefToEventAction } from '../utils/analytics';

const Card = ({ asLink = true, size = 'sm', href, title, text, icon: Icon, pro, onClick, ...props }) => {
  const router = useRouter();

  const handleClick = useCallback(() => {
    sendEvent({
      category: 'click-to-open-pages',
      action: hrefToEventAction(href),
      label: 'main',
    });
  }, [href]);

  const card = (
    <a
      className={classNames(
        'card',
        // size && `card--size-${size}`,
      )}
      onClick={handleClick}
      {...(asLink ? {} : { href: getUrl({ router, pathname: href }) })}
      {...props}
    >
      <div className="card__header">
        <div className="card__title">
          {title}
        </div>
        {pro && (
          <div className="card__label">
            PRO
          </div>
        )}
        {Icon && (
          <Icon className="card__icon" aria-hidden="true" />
        )}
      </div>
      {size !== 'sm' && text && (
        <div className="card__text">
          {text}
        </div>
      )}
    </a>
  );

  if (asLink) {
    return (
      <Link href={href}>
        {card}
      </Link>
    );
  }

  return card;
};

Card.propTypes = {
  asLink: PropTypes.bool,
  size: PropTypes.oneOf([
    'sm',
    'md',
  ]),
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.elementType,
  pro: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Card;
